/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { BabylonChannelSummaryInfo } from './BabylonChannelSummaryInfo';

export type BabylonRelayerChannelInfo = {
    STAT: BabylonRelayerChannelInfo.STAT;
    CNNID: string;
    BBN: BabylonChannelSummaryInfo;
    CNTPRTY: BabylonChannelSummaryInfo;
    SNDTRXCNT: string;
    RCVTRXCNT: string;
    ASTCNT: string;
    AG: string;
    CTUT: number;
};

export namespace BabylonRelayerChannelInfo {

    export enum STAT {
        STATE_OPENINIT = 'STATE_OPENINIT',
        STATE_TRYOPEN = 'STATE_TRYOPEN',
        STATE_OPEN = 'STATE_OPEN',
        STATE_CLOSE = 'STATE_CLOSE',
    }


}

